import { render, staticRenderFns } from "./authorizationForm.vue?vue&type=template&id=59773178&scoped=true&"
import script from "./authorizationForm.vue?vue&type=script&lang=js&"
export * from "./authorizationForm.vue?vue&type=script&lang=js&"
import style0 from "./authorizationForm.vue?vue&type=style&index=0&id=59773178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59773178",
  null
  
)

export default component.exports